import React from 'react';
import { Carousel, Image } from '@dotcom/crown-ui';
import { PreviewImage } from '../../../global-types/images';

import styles from '../preview.module.scss';

type PreviewImageCarouselProps = {
  previewImages: PreviewImage[];
  slideIndex: number;
  onAfterSlide: (newIndex: number) => void;
};

export const PreviewImageCarousel = ({ previewImages, slideIndex, onAfterSlide }: PreviewImageCarouselProps) => {
  return (
    <div className={styles['carousel-container']}>
      <Carousel
        disableKeyboardControls={true}
        slidesToScroll={1}
        currentSlideIndex={slideIndex}
        onAfterSlide={onAfterSlide}
        slideClass={styles.slide}
        addClass={styles.carousel}
      >
        {previewImages.length > 0 &&
          previewImages.map((image, index) => {
            return (
              <Image
                src={image.dataURL}
                alt={image.type}
                pictureClass={styles['preview-image']}
                className={styles.image}
                key={`preview-image-${index}`}
              />
            );
          })}
      </Carousel>
    </div>
  );
};
